var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reward-records coming-soon"},[_c(_setup.PageHeader,{staticStyle:{"margin-bottom":"20px"},attrs:{"title":"我的奖惩记录"}}),_c('ming-table',{attrs:{"fields":_setup.column,"data":_setup.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }